<div class="container-fluid" id="skiplink" role="navigation">
  <ds-link standalone="true" href="#main-content" skip="true">{{ 'go_to_main_content' | translate }}</ds-link>
  @if (showSkipToAiChatLink$ | async) {
    <ds-link standalone="true" href="#ai-chat-button" skip="true" data-test-id="skip-to-ai-chat-link">
      {{ 'skip_to_ai_chat' | translate }}
    </ds-link>
  }
</div>

<div class="layout-container" [attr.data-test-id]="isVerticalNavigationEnabled() ? 'vertical-layout-container' : null">
  @if (isVerticalNavigationEnabled() && showVerticalNavigationPanel()) {
    <vertical-navigation-panel></vertical-navigation-panel>
  }
  <div class="page-content" [class.ai-chat-expanded]="isAiChatExpanded()">
    <compound-navbar></compound-navbar>
    <div class="sections" [class.ai-chat-expanded]="isAiChatExpanded()">
      @if (!isAiChatExpanded()) {
        <div class="main-content-container">
          <main
            class="main-content"
            [class.main-content--fill]="fillMainContent()"
            id="main-content"
            tabindex="-1"
            data-test-id="main-content"
          >
            <ng-container [ngTemplateOutlet]="routerOutlet"></ng-container>
          </main>
          <app-footer></app-footer>
        </div>
      }
      @if (showAiChatPanel$ | async) {
        <div class="ai-chat-panel-container" [class.expanded]="isAiChatExpanded()">
          <app-ai-chat-panel class="ai-chat-panel"></app-ai-chat-panel>
        </div>
      }
    </div>
  </div>
</div>

@if (isLoading) {
  <app-global-spinner></app-global-spinner>
}
